<template>
  <div class="virtual-keyboard">
    <div class="main">
      <div class="title">
        Main
      </div>
      <div
        class="key"
        v-for="(mainKey, key) in mainKeys"
        :key="key"
        :class="{ selected: selectedKey === key }"
        :style="mainKey.style"
        @click="$emit('key-click', key)"
      >
        <div class="text" v-html="mainKey.text"></div>
      </div>
    </div>
    <div class="center-cluster">
      <div class="title">
        Center Cluster
      </div>
      <div
        class="key"
        v-for="(centerClusterKey, key) in centerClusterKeys"
        :key="key"
        :class="{ selected: selectedKey === key }"
        :style="centerClusterKey.style"
        @click="$emit('key-click', key)"
      >
        <div class="text" v-html="centerClusterKey.text"></div>
      </div>
    </div>
    <div class="numpad">
      <div class="title">
        Numpad
      </div>
      <div
        class="key"
        v-for="(numpadKey, key) in numpadKeys"
        :key="key"
        :class="{ selected: selectedKey === key }"
        :style="numpadKey.style"
        @click="$emit('key-click', key)"
      >
        <div class="text" v-html="numpadKey.text"></div>
      </div>
    </div>
    <div class="media" v-if="version === 'r2'">
      <div class="title">
        Media
      </div>
      <div
        class="key"
        v-for="(mediaKey, key) in mediaKeys"
        :key="key"
        :class="{ selected: selectedKey === key }"
        :style="mediaKey.style"
        @click="$emit('key-click', key)"
      >
        <div class="text" v-html="mediaKey.text"></div>
      </div>
    </div>
    <div class="function" v-if="version === 'r2'">
      <div class="title">
        Function
      </div>
      <template v-for="(r2Key, key) in r2Keys">
        <div
          class="key"
          :key="key"
          :class="{ selected: selectedKey === key }"
          :style="r2Key.style"
          @click="$emit('key-click', key)"
        >
          <div class="text" v-html="r2Key.text"></div>
        </div>
        <div class="desc" :key="'desc' + key">
          {{ r2Key.desc[isCN ? "cn" : "en"] }}
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  mainKeys,
  centerClusterKeys,
  numpadKeys,
  mediaKeys,
  r2Keys,
} from "./VirtualKeyboard";
export default {
  name: "CVirtualKeyboard",
  props: {
    selectedKey: String,
    layerNum: Number,
    layerIndex: Number,
  },
  data() {
    return {
      mainKeys,
      centerClusterKeys,
      numpadKeys,
      mediaKeys,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("profile", {
      version: "version",
    }),
    r2Keys() {
      let keys = { ...r2Keys };
      for (let index = 3; index <= 7; index++) {
        let key = ["key_cmd_set_key_layer" + index];
        delete keys[key];
        if (index <= this.layerNum) {
          keys[key] = r2Keys[key];
        }
        key = ["key_hold_set_key_layer" + index];
        delete keys[key];
        if (index <= this.layerNum) {
          keys[key] = r2Keys[key];
        }
      }
      return keys;
    },
  },
};
</script>
<style lang="scss" scoped>
$key-width: 52px;
$key-margin: 6px;

.virtual-keyboard {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  > * {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 (10px - $key-margin) 0 10px;

    .title {
      width: 100%;
      font-size: 12px;
      color: $primary-color;
      text-align: left;
      margin: 20px 0 10px 0;
      white-space: nowrap;
    }

    .key {
      @include flex-center;
      width: $key-width;
      height: $key-width;
      margin: 0 $key-margin $key-margin 0;
      border: 1px solid #ffffff;
      cursor: pointer;

      .text {
        font-size: 24px;
        color: #ffffff;
        transform: scale(0.5);
        line-height: 1.3;
      }

      &.selected {
        border-color: $active-color;
        background: $active-color;
      }

      &:hover {
        border-color: $primary-color;
        background: $primary-color;
      }
    }

    .desc {
      width: ($key-width + $key-margin) * 6.3;
      line-height: $key-width / 2;
      font-size: 16px;
      text-align: left;
    }
  }

  .main {
    width: ($key-width + $key-margin) * 15;
  }

  .center-cluster {
    width: ($key-width + $key-margin) * 3;
  }

  .numpad {
    width: ($key-width + $key-margin) * 4;
  }
}
</style>
